module.exports = __webpack_public_path__ + "static/img/index_feedback.8ae834b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_feedback.jpg
// module id = zfuQ
// module chunks = 17